import { Button } from "@mui/material";

export default function ActionButton(props) {
  const { children, disabled, onClick, variant, color, ...other } = props;
  const config = { ...other };

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      color={color}
      {...config}
    >
      {children}
    </Button>
  );
}
